var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7ba23576874649d56ffc1ce3456cf446adbf5ca6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["help-center@klaviyo-1"]={id:"7ba23576874649d56ffc1ce3456cf446adbf5ca6"};
      